import { homeHeaderItemsConfig } from "../config/homeHeaderConfig";
import { headerComponentMap } from "../../../pages/main/header/components/DynamicHeader";

export const HomeDynamicHeader: React.FC = () => {
    return (
        <div className="flex items-center justify-end gap-4 p-1">
            {homeHeaderItemsConfig.map((item) => {
                const ComponentToRender = headerComponentMap[item.type];
                return <ComponentToRender key={item.id} {...item} />;
            })}
        </div>
    );
};